export default __webpack_public_path__ + "static/media/property_760.12eddbbf.png";